import _ from 'lodash-es';

export default class MfValuesController {
	/* @ngInject */
	constructor() {
		this.disabled = false;
		this.filter = {};

		/**
		 * @type {?Function}
		 */
		this.onDelete = null;

		this.readOnly = false;

		/**
		 * @type {any[]}
		 */
		this.values = [];
	}

	/**
	 * @param {Event} event
	 * @param {any} value
	 */
	delValue(event, value) {
		_.remove(this.values, v => v.kid === value.kid);

		if (typeof this.onDelete === 'function') {
			this.onDelete({
				$item:  value,
				$event: event,
			});
		}
	}
}
